import { getRuntimeEnv } from "~/utils/getRuntimeEnv";

const runtimeEnv = getRuntimeEnv();

export const GOOGLE_PROJECT_ID = runtimeEnv?.VITE_GOOGLE_ANALYTIC_KEY;
export const CLARITY_PROJECT_ID = runtimeEnv?.VITE_CLARITY_KEY;
export const GTM_CONTAINER_ID = runtimeEnv?.VITE_GTM_ID;
